import IForm from 'data/questionnaires/IForm'
import { IReduxAction } from '../IReduxAction'
import ActionTypes from './types'

export interface IUserState {
  allForms: { [type: string]: IForm[] }
  errorCode: string
  errorMessage: string
}

export const initState: IUserState = {
  allForms: {},
  errorCode: '',
  errorMessage: ''
}

export default (state = initState, action: IReduxAction): IUserState => {
  switch (action.type) {
    case ActionTypes.add_forms:
      return {
        ...state,
        allForms: {
          ...state.allForms,
          [action.payload.data.type]: action.payload.data.forms
        }
      }

    case ActionTypes.clear_forms: {
      return initState
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/forms/index.ts